/* eslint-disable @typescript-eslint/no-explicit-any */
import { PAYPAL_TYPES } from '@/services/constants';
import { Helpers } from '@/services/helpers';
export function buildUpsellPaymentPayload({ state, rootState, payload, }) {
    const { paymentPayload } = rootState.payment;
    const payment = Helpers.cleanEmptyKeysFromObj(buildPaymentObject(state, rootState, payload));
    const orders = resolveUpsellOrders(state, payload);
    const commonFields = extractCommonFields(paymentPayload);
    const uuid = rootState['have-lead'].uuid;
    const siteCountry = Helpers.getCountryFromUrl();
    const result = {
        ...state.upsellPayload,
        orders,
        payment,
        ...commonFields,
        siteCountry,
        locationOrigin: commonFields.locationOrigin,
        uuid,
    };
    if (paymentPayload?.fieldsDocumentId) {
        result.fieldsDocumentId = paymentPayload.fieldsDocumentId;
    }
    return Helpers.cleanEmptyKeysFromObj(result);
}
export function buildPaymentObject(state, rootState, payload) {
    const { paymentPayload, is3DSecureRequired } = rootState.payment;
    const { method, type, transactionId, orderId, variant } = paymentPayload.payment;
    const payment = {
        method,
        type,
        ...state.upsellPayload.payment,
        orderId,
        variant,
    };
    if (method === PAYPAL_TYPES.global || method === PAYPAL_TYPES.us) {
        payment.transactionId = transactionId;
        delete payment.previousOrderId;
    }
    else if (is3DSecureRequired && 'token' in payload) {
        payment.token = payload.token;
        delete payment.previousOrderId;
    }
    return payment;
}
export function resolveUpsellOrders(state, payload) {
    const orderKeyMap = {
        isDonation: 'donation',
        isFastFoodMeal: 'fastFoodMeal',
        isFastFoodMealPilates: 'fastFoodMealPilates',
        isPremiumContent: 'premiumContent',
        isAlcohol: 'alcohol',
        isDetox: 'detox',
        isSweetTreatsMeal: 'sweetTreatsMeal',
        is12Month: 'upsell12Month',
        is12MonthLifetime: 'upsell12MonthLifetime',
        isUpsellYogaAndHealthyBack: 'upsellYogaAndHealthyBack',
        isUpsellDigitalProductsBundle: 'upsellDigitalProductsBundle',
        isUpsellMealPlanSupplementsGuide: 'upsellMealPlanSupplementsGuide',
        isUpsellCoach: 'upsellCoach',
    };
    const match = Object.entries(orderKeyMap).find(([key]) => payload[key]);
    if (match) {
        return [state[match[1]]];
    }
    if (Array.isArray(state.upsellPayload.orders)) {
        return state.upsellPayload.orders.map((o) => o.id || o);
    }
    return [state.upsellPayload.orders];
}
export function extractCommonFields(paymentPayload) {
    const { email, firstName, lastName, locationOrigin } = paymentPayload;
    return {
        email,
        firstName,
        lastName,
        locationOrigin,
    };
}
